<template>
    <v-menu
        :close-on-click="true"
        :close-on-content-click="false"
        :return-value="time"
        :style="{width:width+'px'}"
        max-width="290px"
        min-width="290px"
        offset-y
        ref="menu"
        transition="scale-transition"
        v-model="active">
        <template v-slot:activator="{ on }">
            <v-text-field
                :value="time"
                :label="label"
                readonly
                outlined
                dense
                hide-details
                v-on="on"
            ></v-text-field>
        </template>
        <v-time-picker
            format="24hr"
            scrollable
            :value="time"
            @change="onChangeTime"
        >
        </v-time-picker>
    </v-menu>
</template>

<script>
import {DateTime} from 'luxon';
import CoreDate from "./CoreDate";

export default {
    name: "AdminTimePicker",
    mixins: [CoreDate],
    props: {
        width: {
            type: Number,
            default: 80
        },
        label: String,
        time: String,
    },

    data() {
        return {
            active: false,
        }
    },

    computed: {
        styleObject() {
            return {
                width: this.width + 'px',
            };
        },
    },

    methods: {
        format(date) {
            return DateTime.fromISO(date).get('day');
        },
        onChangeTime(value) {
            this.$emit('update:time', value)
            this.active = false
        },
    },
}
</script>

<style scoped>
>>> input:read-only, >>> input {
    background-color: transparent !important;
    border: 0 !important;
}
</style>
